export const TYPE_REASSIGN = 'reassign'; // friend declined ticket and user need to assing new or release ACTION: reassign new user

export const TYPE_ACCEPT = 'accept'; //accept ticket or kids
export const TYPE_PAY = 'pay';
export const TYPE_TEXT = 'text';
